import { ModalSweetAlert } from "@components/general/Alertas/Alertas";
import { DataTablesRecipient } from "@components/general/DataTablesRecipient/DataTablesRecipient";
import { getEstudiantes } from "@helpers/httpRequests/httpRequestsUsuarios/estudiantes/httpRequestsEstudiantes";
import { getUsuariosLecturaVeloz } from "@helpers/httpRequests/httpRequestsUsuarios/lecturaVeloz/httpRequestsUsuariosLecturaVeloz";
import React, { useEffect, useMemo, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import columnasCambiosLicencia from "./columnasCambiosLicencia";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBookReader } from "@fortawesome/free-solid-svg-icons";
import CambioLicencia from "./CambioLicencia";
import { MaterialReactTable } from "material-react-table";
import { MRT_Localization_ES } from "material-react-table/locales/es";
import { Box, IconButton } from "@mui/material";

const TableCambiosLicencia = () => {
  const [datosUsuarios, setDatosUsuarios] = useState([]);

  const [dataTableColumns, setDataTableColumns] = useState([]);

  const [refetchUsuarios, setRefetchUsuarios] = useState(false);

  const handleCambioLicencia = async ({ currentTarget }) => {
    const idPersona = parseInt(currentTarget.id);

    const dataUsuario = datosUsuarios.filter(
      (usuario) => usuario.idPersona === idPersona
    )[0];

    await ModalSweetAlert({
      title: "Cambiar Licencia",
      html: (
        <CambioLicencia
          usuario={dataUsuario}
          setRefetchUsuarios={setRefetchUsuarios}
        />
      ),
      showConfirmButton: false,
      showCloseButton: true,
    });
  };

  useEffect(() => {
    const consultarDatosUsuarios = async () => {
      let auxData = [];

      try {
        let { data: estudiantes } = await getEstudiantes();

        if (!Array.isArray(estudiantes)) {
          estudiantes = [estudiantes];
        }

        auxData = [...auxData, ...estudiantes];
      } catch (error) {
        console.log("Error al consultar los estudiantes registrados: ", error);
      }

      try {
        let { data: usuariosLecturaVeloz } = await getUsuariosLecturaVeloz();

        if (!Array.isArray(usuariosLecturaVeloz)) {
          usuariosLecturaVeloz = [usuariosLecturaVeloz];
        }

        auxData = [...auxData, ...usuariosLecturaVeloz];
      } catch (error) {
        console.log(
          "Error al consultar los usuarios de lectura veloz registrados: ",
          error
        );
      }

      setDatosUsuarios(
        auxData.sort(
          (a, b) => parseInt(a.folioContrato) - parseInt(b.folioContrato)
        )
      );
    };

    consultarDatosUsuarios();
  }, []);

  useEffect(() => {
    if (refetchUsuarios) {
      const consultarDatosUsuarios = async () => {
        let auxData;

        try {
          let { data: estudiantes } = await getEstudiantes();

          if (!Array.isArray(estudiantes)) {
            estudiantes = [estudiantes];
          }

          auxData = [...auxData, ...estudiantes];
        } catch (error) {
          console.log(
            "Error al consultar los estudiantes registrados: ",
            error
          );
        }

        try {
          let { data: usuariosLecturaVeloz } = await getUsuariosLecturaVeloz();

          if (!Array.isArray(usuariosLecturaVeloz)) {
            usuariosLecturaVeloz = [usuariosLecturaVeloz];
          }

          auxData = [...auxData, ...usuariosLecturaVeloz];
        } catch (error) {
          console.log(
            "Error al consultar los usuarios de lectura veloz registrados: ",
            error
          );
        }

        setDatosUsuarios(
          auxData.sort(
            (a, b) => parseInt(a.folioContrato) - parseInt(b.folioContrato)
          )
        );

        setRefetchUsuarios(false);
      };

      consultarDatosUsuarios();
    }
  }, [refetchUsuarios]);

  // useEffect(() => {
  // 	if (datosUsuarios.length > 0) {

  // 		setDataTableColumns([
  // 			...columnasCambiosLicencia,
  // 			{
  // 				name: "Cambiar licencia al usuario",
  // 				cell: (row) => (
  // 					<>
  // 						<span id={`select-${row.idPersona}`} className="me-1 pointer" onClick={handleCambioLicencia}>
  // 							<FontAwesomeIcon icon={faBookReader} className="text-primary" />
  // 						</span>
  // 					</>
  // 				),
  // 				ignoreRowClick: true,
  // 				allowOverflow: true,
  // 				button: true,
  //                 center: true,
  //                 width: '200px'
  // 			},
  // 		]);
  // 	}
  // }, [datosUsuarios]);

  const columnas = useMemo(() => [
    {
      accessorKey: "folioContrato",
      header: "Folio",
      size: 50,
    },
    {
      accessorKey: "nombreCompleto",
      header: "Nombre",
    },
    {
      accessorKey: "apellidos",
      header: "Apellidos",
    },
    {
      accessorKey: "rol",
      header: "rol",
    },
    {
      accessorKey: "correo",
      header: "Correo",
    },
    {
      accessorKey: "nombreLicencia",
      header: "Licencia Actual",
    },
  ]);

  return (
    <Container fluid>
      <Row>
        <Col>
          {/* <DataTablesRecipient columns={dataTableColumns} data={datosUsuarios} /> */}
          <MaterialReactTable
            localization={MRT_Localization_ES}
            columns={columnas}
            data={datosUsuarios}
            enableRowActions
            positionActionsColumn="last"
            renderRowActions={({ row, table }) => (
              <Box sx={{ display: "flex", flexWrap: "nowrap", gap: "8px" }}>
                <IconButton
                  color="primary"
                  id={row.original.idPersona}
                  onClick={handleCambioLicencia}
                >
                  <FontAwesomeIcon
                    icon={faBookReader}
                    className="text-primary"
                  />
                </IconButton>
              </Box>
            )}
          />
        </Col>
      </Row>
    </Container>
  );
};

export default TableCambiosLicencia;
